import React from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { FloatingPhoneButton } from "@/components/mobile/FloatingPhoneButton";
import { ConsentBanner } from "@/components/seo/ConsentBanner";
import ScrollToTop from "@/components/ScrollToTop";
import Index from "./pages/Index";
import Diensten from "./pages/Diensten";
import Zonnepanelen from "./pages/Zonnepanelen";
import Warmtepompen from "./pages/Warmtepompen";
import Thuisbatterijen from "./pages/Thuisbatterijen";
import Zonneboilers from "./pages/Zonneboilers";
import ZonnepaneelPakketten from "./pages/ZonnepaneelPakketten";
import Offerte from "./pages/Offerte";
import Contact from "./pages/Contact";
import OfferteSnell from "./pages/OfferteSnell";
import OverOns from "./pages/OverOns";
import Portfolio from "./pages/Portfolio";
import Maatwerk from "./pages/Maatwerk";
import BlogIndex from "./pages/BlogIndex";
import BlogPost from "./pages/BlogPost";
import NieuwsIndex from "./pages/NieuwsIndex";
import NieuwsPost from "./pages/NieuwsPost";
import Elektra from "./pages/Elektra";
import Laadpalen from "./pages/Laadpalen";
import Airco from "./pages/Airco";
import SmartHome from "./pages/SmartHome";
import Audio from "./pages/Audio";
import SmartHomeEnergyHub from "./pages/SmartHomeEnergyHub";
import ISDESubsidieCalculator from "./pages/ISDESubsidieCalculator";
import { BesparingCalculator } from "./pages/BesparingCalculator";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AlgemeneVoorwaarden from "./pages/AlgemeneVoorwaarden";
import CookiePolicy from "./pages/CookiePolicy";
import PilotProjecten from "./pages/PilotProjecten";
import CoopSnellaadparking from "./pages/CoopSnellaadparking";

import NotFound from "./pages/NotFound";
import KnowledgeHub from "./pages/KnowledgeHub";
import ZonnepanelenArnhem from "./pages/local/ZonnepanelenArnhem";
import LaadpaalDuiven from "./pages/local/LaadpaalDuiven";
import WarmtepompWestervoort from "./pages/local/WarmtepompWestervoort";
import ZonnepanelenWestervoort from "./pages/local/ZonnepanelenWestervoort";
import LaadpaalWestervoort from "./pages/local/LaadpaalWestervoort";
import ThuisbatterijWestervoort from "./pages/local/ThuisbatterijWestervoort";
import AircoWestervoort from "./pages/local/AircoWestervoort";
import SmartHomeWestervoort from "./pages/local/SmartHomeWestervoort";
import ZonnepanelenDuiven from "./pages/local/ZonnepanelenDuiven";
import WarmtepompDuiven from "./pages/local/WarmtepompDuiven";
import LaadpaalArnhem from "./pages/local/LaadpaalArnhem";
import WarmtepompArnhem from "./pages/local/WarmtepompArnhem";
import InstallationRegistration from "./pages/InstallationRegistration";
import UitlegNormen from "./pages/UitlegNormen";
import DataInzichten from "./pages/DataInzichten";
import OpleverDocument from "./pages/OpleverDocument";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/diensten" element={<Diensten />} />
            <Route path="/zonnepanelen" element={<Zonnepanelen />} />
            <Route path="/zonnepaneel-pakketten" element={<ZonnepaneelPakketten />} />
            <Route path="/warmtepompen" element={<Warmtepompen />} />
            <Route path="/thuisbatterijen" element={<Thuisbatterijen />} />
            <Route path="/zonneboilers" element={<Zonneboilers />} />
            <Route path="/elektra" element={<Elektra />} />
            <Route path="/laadpalen" element={<Laadpalen />} />
            <Route path="/airco" element={<Airco />} />
            <Route path="/smart-home" element={<SmartHome />} />
            <Route path="/audio" element={<Audio />} />
          <Route path="/isde-subsidie-calculator" element={<ISDESubsidieCalculator />} />
          <Route path="/besparingscalculator" element={<BesparingCalculator />} />
           <Route path="/installatie-registreren" element={<InstallationRegistration />} />
           <Route path="/uitleg-normen" element={<UitlegNormen />} />
           <Route path="/data-inzichten" element={<DataInzichten />} />
           <Route path="/opleverdocument" element={<OpleverDocument />} />
            <Route path="/offerte" element={<Offerte />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/offerte-snel" element={<OfferteSnell />} />
            <Route path="/over-ons" element={<OverOns />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/maatwerk" element={<Maatwerk />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/nieuws" element={<NieuwsIndex />} />
            <Route path="/nieuws/:slug" element={<NieuwsPost />} />
            <Route path="/kennisbank" element={<KnowledgeHub />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/algemene-voorwaarden" element={<AlgemeneVoorwaarden />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/pilot-projecten" element={<PilotProjecten />} />
           <Route path="/coop-snellaadparking" element={<CoopSnellaadparking />} />
           <Route path="/smart-home-energy-hub" element={<SmartHomeEnergyHub />} />
           
           
           {/* Local Landing Pages */}
           <Route path="/zonnepanelen-arnhem" element={<ZonnepanelenArnhem />} />
           <Route path="/laadpaal-duiven" element={<LaadpaalDuiven />} />
           <Route path="/warmtepomp-westervoort" element={<WarmtepompWestervoort />} />
           
           {/* Westervoort local pages */}
           <Route path="/zonnepanelen-westervoort" element={<ZonnepanelenWestervoort />} />
           <Route path="/laadpaal-westervoort" element={<LaadpaalWestervoort />} />
           <Route path="/thuisbatterij-westervoort" element={<ThuisbatterijWestervoort />} />
           <Route path="/airco-westervoort" element={<AircoWestervoort />} />
           <Route path="/smart-home-westervoort" element={<SmartHomeWestervoort />} />
           
           {/* Duiven local pages */}
           <Route path="/zonnepanelen-duiven" element={<ZonnepanelenDuiven />} />
           <Route path="/warmtepomp-duiven" element={<WarmtepompDuiven />} />
           
           {/* Arnhem local pages */}
           <Route path="/laadpaal-arnhem" element={<LaadpaalArnhem />} />
           <Route path="/warmtepomp-arnhem" element={<WarmtepompArnhem />} />
           
           {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          <FloatingPhoneButton />
          <ConsentBanner />
        </BrowserRouter>
        <Toaster />
        <Sonner />
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
